import { reactLocalStorage } from "reactjs-localstorage";
import { v4 as uuidv4 } from 'uuid';

export const setSearchObj = function(data) {
    reactLocalStorage.setObject('maxxSearchObj', data);
    return true
}
export const getSearchObj = reactLocalStorage.get('maxxSearchObj')
export const deleteSearchObj = function() { reactLocalStorage.remove('maxxSearchObj'); return true}

export const setUniqueId = function () {
    reactLocalStorage.setObject('uniqueId', uuidv4());
    return true
}
export const getUniqueId = reactLocalStorage.get('uniqueId')